import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Subject, Subscription } from "rxjs";

import { AssociacaoService } from "./associacao.service";
import { Carteira } from "../../carteira/carteira.model";
import { DadosCarteiraRegraModel } from "./dados-carteira-regra.model";
import { ExecucaoVigenciaComponent } from "./execucao-vigencia/execucao-vigencia.component";
import { MatStepper } from "@angular/material/stepper";
import { Regra } from "../../regra/regra";
import { STEP_STATE } from "@angular/cdk/stepper";
import { SelecaoCarteiraComponent } from "./selecao-carteira/selecao-carteira.component";
import { SelecaoRegrasComponent } from "../../regra/selecao-regras/selecao-regras.component";
import { ToastService } from "maps-angular-components";
import { ValidacaoSelecaoModel } from "./selecao-carteira/carteira-selecao-model";
import { indicate } from "src/app/shared/util/loading-indicate";

@Component({
  selector: "app-associacao-stepper",
  templateUrl: "./associacao-stepper.component.html",
  styleUrls: ["./associacao-stepper.component.scss"],
})
export class AssociacaoStepperComponent
  implements OnInit, AfterViewInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  @ViewChild("stepper", { static: true })
  public stepper: MatStepper;

  @ViewChild("selecaoRegrasComponent", { static: false })
  private readonly selecaoRegrasComponent: SelecaoRegrasComponent;

  @ViewChild("selecaoCarteiraComponent", { static: false })
  private readonly selecaoCarteiraComponent: SelecaoCarteiraComponent;

  @ViewChild("execucaoVigenciaComponent", { static: false })
  private readonly execucaoVigenciaComponent: ExecucaoVigenciaComponent;

  carteiraRegra$: Subject<DadosCarteiraRegraModel> = new Subject<DadosCarteiraRegraModel>();
  dadosCarteiraRegra = new DadosCarteiraRegraModel();
  validacaoSelecaoModels: ValidacaoSelecaoModel[];

  loading$ = new Subject<boolean>();

  isDisabled: boolean;

  constructor(
    private readonly messageService: ToastService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    public associacaoService: AssociacaoService
  ) {}

  ngOnInit() {
    this.isDisabled = true;
  }

  ngAfterViewInit(): void {
    this.stepper._getIndicatorType = () => STEP_STATE.NUMBER;
  }

  selectionChanged() {
    this.selecaoRegrasComponent.markAsPending();
    this.execucaoVigenciaComponent.markAsPending();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  doneStepper() {
    this.criar();
    this.changeDetectorRef.detectChanges();
  }

  limpar() {
    this.selecaoRegrasComponent.clear();
    this.selecaoCarteiraComponent.clear();
    this.execucaoVigenciaComponent.clear();
    this.stepper.selectedIndex = 0;
  }

  criar() {
    if (this.validacaoSelecaoModels.length === 0) {
      this.messageService.alerta(
        "Nenhuma associação entre carteira e regra está selecionada."
      );
      return;
    }
    this.associacaoService
      .associar(this.validacaoSelecaoModels, this.dadosCarteiraRegra.carteiras)
      .pipe(indicate(this.loading$))
      .subscribe(
        (data) => {
          this.execucaoVigenciaComponent.clear();
          this.selecaoCarteiraComponent.clear();
          this.selecaoRegrasComponent.clear();
          this.stepper.reset();
          this.messageService.textoLight(
            "Associação da(s) carteira(s) e regra(s) realizada com sucesso."
          );
        },
        err => {
          this.messageService.erro("Erro ao executar associação: " + err.error.message);
        }
      );
  }


  updateRegra($event: Regra[]) {
    this.dadosCarteiraRegra.regras = $event;
    this.carteiraRegra$.next(this.dadosCarteiraRegra);
  }

  updateCarteira($event: Carteira[]) {
    this.dadosCarteiraRegra.carteiras = $event;
    this.carteiraRegra$.next(this.dadosCarteiraRegra);
  }

  updateVigencia($event: ValidacaoSelecaoModel[]) {
    this.validacaoSelecaoModels = $event;
    this.checkButtonDisabled();
  }

  private validateAllFieldsFilled() {
    return (
      this.validacaoSelecaoModels.length > 0 &&
      this.validacaoSelecaoModels.find(
        (model) =>
          model.regraNome == null ||
          model.carteiraNome == null ||
          model.processamentoOnlineAtivo == null ||
          model.dataInicioAssociacao == null
      ) == null
    );
  }

  private checkButtonDisabled() {
    this.isDisabled = !this.validateAllFieldsFilled();
  }
}
